export default __webpack_public_path__ + "static/media/raiffeisen_background_l1.d829228a.jpg";